import { z } from "zod/v3";

export const MAX_PROJECT_ISSUE_CATEGORY_NAME_LENGTH = 80;

export const projectIssueCategoryFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, "O nome da categoria é obrigatório")
    .max(
      MAX_PROJECT_ISSUE_CATEGORY_NAME_LENGTH,
      `O nome deve possuir no máximo ${MAX_PROJECT_ISSUE_CATEGORY_NAME_LENGTH} caracteres`,
    ),
});

export type ProjectIssueCategoryFormInput = z.input<
  typeof projectIssueCategoryFormSchema
>;

export type ProjectIssueCategoryFormData = z.output<
  typeof projectIssueCategoryFormSchema
>;
